Customer.Filters ||= {}

class Customer.ResponseTemplateTagsView extends Backbone.View
  template: JST['backbone/templates/customer/filters/tags']
  events:
    'click .open-keyword-tags': 'openKeywordTagsClick'
    'click .tags-filter-cancel-button': 'cancelTagsModalSelection'
    'click .tags-filter-apply-button': 'tagsModalSelectionDone'

  initialize: (@options = {}) ->
    @shouldTriggerEvents = false
    @hideToggle = @options.hideToggle
    @hiddenTags = @options.hiddenTags
    @disableDoneButtonWhenEmpty = @options.disableDoneButtonWhenEmpty
    @tagsByClientCode = @options.tagsByClientCode
    @intelligentTags = @options.intelligentTags

    @keywordsFilterView = new Customer.ResponseTemplateIntelligentTagsView
      tagsByClientCode: @tagsByClientCode
      hiddenTags: @hiddenTags
      intelligentTags: @intelligentTags
      useCustomValues: @options.useCustomValues

    @listenTo(@keywordsFilterView, 'change', @_updateDoneButton) if @disableDoneButtonWhenEmpty
    @_renderKeywordsFilter()

  render: ->
    @$el.html @template
    @_renderKeywordsFilter()
    @_tagsSelectionToggle()
    @$el.find('#keyword-tags-container').html(@keywordsFilterView.render().el)
    @$el.find('.open-keyword-tags').addClass('hidden') if @hideToggle
    @_updateDoneButton() if @options.disableDoneButtonWhenEmpty
    @

  toggle: ->
    @$el.find('#keyword-tags-container').toggleClass('hidden')
    @$el.find('.chevron-up').toggleClass('hidden')
    @$el.find('.chevron-down').toggleClass('hidden')

  openKeywordTagsClick:(event)->
    event.preventDefault()
    event.stopImmediatePropagation()
    @toggle()
    @_tagsSelectionToggle()

  _tagsSelectionToggle:()->
    if @hasSelectedTags()
      @$el.find('.no-tags-selected').addClass('hidden')
      @$el.find('.tags-selected').removeClass('hidden')
    else
      @$el.find('.no-tags-selected').removeClass('hidden')
      @$el.find('.tags-selected').addClass('hidden')


  cancelTagsModalSelection:(event)->
    event.preventDefault()
    event.stopImmediatePropagation()
    @toggle()
    @keywordsFilterView.render()
    @_tagsSelectionToggle()

  tagsModalSelectionDone:(event)->
    event.preventDefault()
    event.stopImmediatePropagation()
    @toggle()
    @_tagsSelectionToggle()

  getIntelligentTags: ->
    @keywordsFilterView.getValues()

  hasSelectedTags:->
    values = @keywordsFilterView.getValues()
    selected = values.main_tags.concat(values.secondary_tags).concat(values.excluded_tags)
    selected.length > 0

  _renderKeywordsFilter: ->
    @keywordsFilterView.render()
    @_tagsSelectionToggle()
    @

  _updateDoneButton: ->
    disabled = !@keywordsFilterView.someValueSelected()
    @$el.find('#tags-modal-selection-done').prop('disabled', disabled)
